// src/store/modules/wish.js
import { getRandomWishes,publishWish,getWishDetail } from '@/api/wish'

const state = {
  wishes: [],
  currentWish: null,
  loading: false
}

const mutations = {
  SET_WISHES(state, wishes) {
    state.wishes = wishes
  },
  SET_CURRENT_WISH(state, wish) {
    state.currentWish = wish
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  ADD_WISH(state, wish) {
    state.wishes.push(wish)
    if(state.wishes.length >= 51){
      state.wishes.splice(0, 1)
    }
  },
  UPDATE_WISH(state, updatedWish) {
    const index = state.wishes.findIndex(w => w.id === updatedWish.id)
    if (index !== -1) {
      state.wishes.splice(index, 1, updatedWish)
    }
  },
  REMOVE_WISH(state, wishId) {
    const index = state.wishes.findIndex(w => w.id === wishId)
    if (index !== -1) {
      state.wishes.splice(index, 1)
    }
  }
}

const actions = {
  // 发布愿望
  async publishWish({ commit, state }, wishData) {
    try {
      const response = await publishWish(wishData)
      if (response.code === 200) {
        return response.data
      } else {
        throw new Error(response.message || '发布失败')
      }
    } catch (error) {
      console.error('发布愿望失败:', error)
      throw error
    }
  },
  // 获取随机许愿
  async fetchRandomWishes({ commit }) {
    try {
      commit('SET_LOADING', true)
      const response = await getRandomWishes()
      if (response.code === 200) {
        commit('SET_WISHES', response.data)
        return response.data
      } else {
        throw new Error(response.message || '获取许愿列表失败')
      }
    } catch (error) {
      console.error('获取许愿列表失败:', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  // 获取愿望详情
  async getWishDetail({ commit }, wishId){
    try {
      console.log("即将调用获取愿望详情API,wishId = " + wishId)
      const response = await getWishDetail(wishId)
      console.log("已获取到愿望详情：" + response)
      if (response.code === 200) {
        return response.data
      } else {
        throw new Error(response.message || '获取许愿详情失败')
      }
    } catch (error) {
      console.error('获取许愿详情:', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 设置当前选择的愿望
  setCurrentWish({ commit }, wish) {
    commit('SET_CURRENT_WISH', wish)
  },

  // 清空愿望列表
  clearWishes({ commit }) {
    commit('SET_WISHES', [])
  }
}

const getters = {
  wishes: state => state.wishes,
  currentWish: state => state.currentWish,
  wishLoading: state => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
